// deps
import cx from "classnames";
import React, { memo } from "react";
import styles from "../CartGroup.scss";

interface CartGroupTitleProps {
    title: string;
    "data-testid"?: string;
    headerClassName?: string;
}

function CartGroupTitle({
    title,
    "data-testid": dataTestId,
    headerClassName,
}: CartGroupTitleProps): React.ReactElement {
    const headerClass = cx(styles.cartGroupHeader, headerClassName);

    return (
        <div className={headerClass}>
            <h2 className={styles.cartGroupHeaderTitle} data-testid={dataTestId}>
                {title}
            </h2>
        </div>
    );
}

export default memo(CartGroupTitle);
